import { TextField } from '@mui/material';
import { useIntl } from 'react-intl';
import type { TreatmentStartEdit } from '../hooks/useTreatmentStartEdit';

/**
 * A treatment start date input driven by `useTreatmentStartEdit`, drawn like
 * the choice pickers beside it. A half-typed date is flagged and not saved.
 */
export default function TreatmentStartField({
    edit,
    disabled,
}: {
    edit: TreatmentStartEdit;
    disabled: boolean;
}) {
    const intl = useIntl();

    return (
        <TextField
            type="date"
            size="small"
            fullWidth
            // The native picker draws its icon and popup in the page's
            // colour scheme, not the theme's.
            sx={(theme) => ({
                '& .MuiOutlinedInput-root': { height: 28 },
                '& .MuiInputBase-input': {
                    fontSize: 12,
                    colorScheme: theme.palette.mode,
                },
            })}
            value={edit.value}
            disabled={disabled}
            inputProps={{
                'aria-label': intl.formatMessage({
                    id: 'patientList.column.treatmentStart',
                }),
            }}
            error={edit.incomplete}
            helperText={
                edit.incomplete
                    ? intl.formatMessage({
                          id: 'patientList.intake.treatmentStartIncomplete',
                      })
                    : undefined
            }
            onChange={edit.onChange}
            onBlur={edit.onBlur}
        />
    );
}
